import React, { useContext, useEffect, useRef, useState } from 'react';
import { render } from 'react-dom';
import ModalFluent from '../../components/tools/modalFluent/ModalFluent';
import LenguajeContext from '../../context/Lenguaje/lenguajeContext';
import { useNavigate, useParams } from 'react-router-dom';

import HeaderForm from '../../components/Forms/headerForm/headerForm.component';
import ContainerBaseLoading from '../../components/containers/baseLoading/containerBaseLoading.component.jsx';
import { ReactComponent as IconResetMfa } from '../../assets/img/ico-restablecer-mfa.svg';
import { PATH_APPLICATION } from '../../assets/settings/settinsrouters';
import { getSafeCookie, getIdLanguage } from '../../helpers/cookieHelper';
import { RequestFetch } from '../../utils/Requests/requests.Controller';
import { GetMessageInfo } from '../../utils/validations/forms';

import ChallengesMfa from './challengesMfa';

const ResetMfa = () => {
    const navigate = useNavigate();
    const { clientName } = useParams();

    const [showChallenges, setShowChallenges] = useState(false);
    const [verificationId, setVerificationId] = useState(null);
    const [isValidating, setIsValidating] = useState(false);
    const [isResetting, setIsResetting] = useState(false);
    const [wasSubmitted, setWasSubmitted] = useState(false);

    const verificationRequested = useRef(false);
    const resetRequested = useRef(false);

    const validateRequest = new RequestFetch('Users/validateMfaReset');
    const resetRequest = new RequestFetch('Users/resetMfaMethods');

    const user = getSafeCookie('dataUser')?.user;
    const idLanguage = getIdLanguage();

    const { stateLanguage } = useContext(LenguajeContext);
    const [controlsPage, setControlsPage] = useState({});

    useEffect(() => {
        let controlsPage = {};
        if (Array.isArray(stateLanguage.lenguaje)) {
            stateLanguage.lenguaje.forEach(page => {
                if (page.path === 'manage-mfa' || page.path === 'verification-challenge' || page.path === 'controls') {
                    page.webcontrolspages.forEach(control => {
                        controlsPage[control.idHtml] = control.languagewebcontrols[0];
                    });
                }
            });
        }
        setControlsPage(controlsPage);
    }, [stateLanguage]);

    const canStartVerification = Boolean(
        user?.id &&
        user?.username &&
        user?.idDomain
    );

    const applicationPath = PATH_APPLICATION
        ? `/${PATH_APPLICATION}`
        : '';

    const goBack = () => {
        navigate(`${applicationPath}/${clientName}/user/`);
    };

    const startVerification = () => {
        verificationRequested.current = false;
        setShowChallenges(true);
    };

    const showModal = (title, type, messages, onClose = goBack) => {
        const description = <>{messages.filter(Boolean).map((message, index) => (
            <React.Fragment key={index}>{index > 0 && <><br /><br /></>}{message}</React.Fragment>
        ))}</>;
        render(<ModalFluent props={{ title, description, type }} hideIcon={true} hideCancel={true}
            actionOnClick={() => {}} objectRequest={onClose} />, document.getElementById('modal'));
    };

    const showRequestError = (error, isReset) => {
        const errors = error?.response?.data?.errors;
        const messages = Array.isArray(errors)
            ? errors.filter(item => item?.detail).map(item => GetMessageInfo(item.code, item.detail))
            : errors && typeof errors === 'object' ? Object.values(errors).flat().filter(item => typeof item === 'string') : [];
        if (messages.length === 0) messages.push(isReset
            ? controlsPage.lblMFAMethodsResetUnconfirmed?.value
            : controlsPage.lblIdentityValidationWasNotSuccessful?.value);
        showModal(controlsPage.lblWarning?.value, 'danger', messages, isReset ? goBack : () => {});
    };

    const showResetResult = (result) => {
        const isComplete = result?.status === 'Complete' && result.isComplete === true && result.executionStarted === true &&
            result.finalVerificationSucceeded === true && result.remainingMethodCount === 0 && Array.isArray(result.errors) && result.errors.length === 0;
        const status = result?.status === 'Complete' && !isComplete ? 'Unconfirmed' : result?.status;
        const isEmpty = isComplete && result.initialMethodCount === 0;
        const resultMessages = {
            Complete: isEmpty ? controlsPage.lblMFAMethodsResetEmpty?.value
                : controlsPage.lblMFAMethodsResetSuccessful?.value,
            Partial: result?.remainingMethodCount > 0 ? controlsPage.lblMFAMethodsResetPartial?.value
                : controlsPage.lblMFAMethodsResetIncidents?.value,
            Failed: controlsPage.lblMFAMethodsResetFailed?.value,
            Accepted: controlsPage.lblMFAMethodsResetAccepted?.value,
            Unconfirmed: controlsPage.lblMFAMethodsResetUnconfirmed?.value
        };
        const messages = [resultMessages[status] || resultMessages.Unconfirmed];
        if (!isComplete) {
            if (result?.finalVerificationSucceeded === true) {
                if (Number.isInteger(result.deletedMethodCount)) messages.push(<>{controlsPage.lblDeletedMFAMethodCount?.value} {result.deletedMethodCount}</>);
                if (Number.isInteger(result.remainingMethodCount)) messages.push(<>{controlsPage.lblRemainingMFAMethodCount?.value} {result.remainingMethodCount}</>);
            }
            if (Array.isArray(result?.errors)) messages.push(...new Set(result.errors.filter(error => error?.message).map(error => GetMessageInfo(error.code, error.message))));
            if (result?.requestId) messages.push(<>{controlsPage.lblMFAResetReference?.value} {result.requestId}</>);
        }
        const type = isEmpty ? 'default' : isComplete ? 'success' : status === 'Partial' || status === 'Accepted' ? 'warning' : 'danger';
        const title = isEmpty ? controlsPage.lblInformation?.value : isComplete ? controlsPage.lblSuccessfulProcess?.value : controlsPage.lblWarning?.value;
        showModal(title, type, messages);
    };

    const handleVerified = async (id) => {
        if (!id || !canStartVerification || verificationRequested.current) return;
        verificationRequested.current = true;
        setIsValidating(true);
        try {
            let requestError;
            const param = new URLSearchParams({ idUser: user.id, verificationId: id }).toString();
            const response = await validateRequest.createItemParams({
                param, ct: 'json', tenant: clientName, headerEx: { idLanguageUser: idLanguage },
                actionClick: () => {}, hideIcon: true, actionError: error => { requestError = error; }
            });
            if (requestError) { showRequestError(requestError, false); return; }
            if (response?.status === 200 && response?.data?.data === true) setVerificationId(id);
            else showRequestError(null, false);
        } catch (error) {
            showRequestError(error, false);
        } finally {
            setShowChallenges(false);
            setIsValidating(false);
        }
    };

    const resetMfaMethods = async () => {
        if (!canStartVerification || !verificationId || resetRequested.current) return;
        resetRequested.current = true;
        setWasSubmitted(true);
        setIsResetting(true);
        try {
            let requestError;
            const response = await resetRequest.createItemParams({
                param: '', ct: 'json', tenant: clientName, body: { idUser: user.id, verificationId },
                headerEx: { idLanguageUser: idLanguage }, actionClick: () => {}, hideIcon: true,
                actionError: error => { requestError = error; }
            });
            if (requestError) { showRequestError(requestError, true); return; }
            showResetResult(response?.status === 200 ? response?.data?.data : null);
        } catch (error) {
            showRequestError(error, true);
        } finally {
            setIsResetting(false);
        }
    };

    if (Object.entries(controlsPage).length === 0) return <ContainerBaseLoading />;

    return (
        <>
            <div className="w10">
                <HeaderForm
                    iconurl={
                        <IconResetMfa
                            fill="var(--color-primary)"
                            className="claso"
                        />
                    }
                    title={controlsPage.lblResetMFAMethods?.value}
                    subtitle={controlsPage.lblAdditionalAuthenticationMethods?.value}
                    className="w83"
                />
            </div>

            {isValidating && <p className="w9 mla mra mg10-h txt--aling-c" role="status">{controlsPage.lblMFAIdentityValidating?.value}</p>}
            {showChallenges && !verificationId && canStartVerification ? (
                <div className="w10 container--flex c--flex-wc">
                    <ChallengesMfa
                        isDisable={false}
                        idLng={idLanguage}
                        state={{
                            user: user.username,
                            roll: user.idDomain
                        }}
                        onVerified={handleVerified}
                    />
                </div>
            ) : (
                <div className="w9 mla mra mg10-h txt--aling-c">
                    {wasSubmitted ? null : verificationId ? (
                        <>
                            <p>{controlsPage.lblMFAIdentityVerified?.value}</p>

                            <p>
                                {controlsPage.lblMFAMethodsResetConfirmation?.value}
                            </p>
                        </>
                    ) : (
                        <>
                            <p>
                                {controlsPage.lblMFAMethodsResetDescription?.value}
                            </p>

                            <p>
                                {controlsPage.lblMFAMethodsResetVerification?.value}
                            </p>
                        </>
                    )}

                    {isResetting && <p role="status">{controlsPage.lblMFAMethodsResetting?.value}</p>}

                    {!canStartVerification && (
                        <p role="alert">
                            {controlsPage.lblMFASessionUnavailable?.value}
                        </p>
                    )}

                    <div className="w10 container--flex c--flex-wsa mg20-h">
                        {/* <button
                            type="button"
                            className="button--default button--second"
                            onClick={goBack}
                        >
                            {controlsPage.smtReturn?.value}
                        </button> */}

                        {verificationId ? (
                            <button
                                type="button"
                                className={`button--default ${canStartVerification && !isValidating && !isResetting && !wasSubmitted ? 'button--primary' : 'button--disable'}`}
                                disabled={!canStartVerification || isValidating || isResetting || wasSubmitted}
                                onClick={resetMfaMethods}
                            >
                                {controlsPage.smtResetMFAMethods?.value}
                            </button>
                        ) : (
                            <button
                                type="button"
                                className={`button--default ${
                                    canStartVerification && !isValidating
                                        ? 'button--primary'
                                        : 'button--disable'
                                }`}
                                disabled={!canStartVerification || isValidating}
                                onClick={startVerification}
                            >
                                {controlsPage.smtNext?.value}
                            </button>
                        )}
                    </div>
                </div>
            )}
        </>
    );
};

export default ResetMfa;